module.exports = __webpack_public_path__ + "static/media/email.217b46c5.svg";